import { buildUrl } from "helpers";
import { instance } from "libs/api";

import {
  ApiRoutesSupport,
  SupportConversationSubRoute
} from "../../constants/enums";
import { InAppConversation } from "../../support.types";
import { SetConversationModeRequestBody } from "./setConversationMode.types";

export const requestSetConversationMode = async ({
  conversationId,
  mode
}: SetConversationModeRequestBody): Promise<InAppConversation> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesSupport.Conversations,
      conversationId,
      SupportConversationSubRoute.Mode
    ),
    { mode }
  );
};
